module.exports = __webpack_public_path__ + "static/Ubuntu-Italic-4b96047e4af086277cdaeb9e60857534.ttf";